export default __webpack_public_path__ + "static/media/noresults.260591e2.svg";